export default __webpack_public_path__ + "static/thumb-landscape-4b3dc088d7fbcc47deef2ebcf99e3007.jpg";